module.exports = __webpack_public_path__ + "static/img/ross_noble_ani_extended_size_00029-fs8.e4b798e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/animation/ross_noble_ani_extended_size_00029-fs8.png
// module id = 182
// module chunks = 0